export default __webpack_public_path__ + "static/media/book.22bd07a7.png";